export const NAME = 'Paywall Credential Manager'
export const NAME_ACRONYM = 'PCM'

export const API_URL = '/api/'
export const BASE_URL = '/'
